import PillarPageLayout from "@/components/PillarPageLayout";
export default function AppellationsViticolesPage() { return <PillarPageLayout slug="appellations-viticoles" />; }
